import { PlainMessage } from "@bufbuild/protobuf";
import { z } from "zod/v3";
import { KapiInstanceMetadata, kapiInstanceMetadataSchema } from "../models/kapiInstanceMetadata";
import { createSchema, ZodOutputFor } from "../zod-utils";
import { ImportKapiInstanceListResponse } from "@opstel/gen/knop/ui/v1/api/instance_loading_pb";
import { ResponseStatus, responseStatusSchema } from "./util/responseStatus";

export interface KapiInstances {
  status: ResponseStatus;
  instances: KapiInstanceMetadata[];
}

const kapiInstanceListSchema = createSchema<
  KapiInstances,
  PlainMessage<ImportKapiInstanceListResponse>
>({
  instances: z.array(kapiInstanceMetadataSchema),
  status: responseStatusSchema,
  message: z.string(),
}) satisfies ZodOutputFor<KapiInstances>;

export function parseKapiInstanceList(
  proto: PlainMessage<ImportKapiInstanceListResponse>,
): KapiInstanceMetadata[] {
  return kapiInstanceListSchema.parse(proto).instances;
}
